import { message, Select, Alert } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  cuentaMask,
  InputNumberItem,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
  dineroDisabledMask,
} from "../../../../Components/Items";
import moment from "moment";

const { Option } = Select;

class VenderActivo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    unidad: null,
    objetoCuentaContable: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarTodo();
    }
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "activosFijos/datosUnidadActivoFijo",
        { entradaSalidaId: this.props.entradaSalidaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ unidad: res.data.unidad });
        }
      });
    await axios
      .post("cuentascontables/selectCuentasContablesFinales", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
    this.setState({ loading: false });
  }

  cerrarVenderActivo(codigo) {
    this.props.cerrarVenderActivo(codigo);
    if (this.formRef.current) this.formRef.current.resetFields();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/venderActivo",
        {
          ...values,
          entradaSalidaId: this.props.entradaSalidaId,
          empresaId: this.props.empresaId,
          fecha: values.fecha || moment(),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado la venta del activo");
          this.cerrarVenderActivo(res.data.polizaId);
        } else {
          message.error(res.data.message || "Hubo un error y no se pudo registrar la venta");
        }
      });
  }

  render() {
    const valorEnLibros = this.state.unidad?.valorEnLibros || 0;
    return (
      <ModalItem
        title="Vender Activo"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarVenderActivo.bind(this)}
        paddingTop
        width={600}
      >
        <Alert
          style={{ marginBottom: 12 }}
          type="info"
          message={`Valor en libros actual: ${dineroDisabledMask(valorEnLibros)}`}
        />
        <Form
          ref={this.formRef}
          name="venderActivo"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
              Registrar Venta
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="fecha" label="Fecha de Venta" margin initialValue={moment()} tooltip={{ title: "Fecha en la que se registra contablemente la venta." }}>
            <DatePickerItem style={{ width: "100%" }} format="DD/MM/YYYY" />
          </FormItem>
          <FormItem name="precioVendido" label="Precio de Venta" required margin tooltip={{ title: "Si vendes por más del valor en libros, la diferencia va a Utilidad de Activo; si vendes por menos, va a Pérdida de Activo." }}>
            <InputNumberItem placeholder="Precio de venta" dinero />
          </FormItem>
          <FormItem name="cuentaCobroId" label="Cuenta de Cobro" required margin tooltip={{ title: "Cuenta de banco, caja o cliente donde entra el dinero de la venta." }}>
            <SelectItem placeholder="Cuenta de cobro (banco/caja/cliente)">
              {this.state.objetoCuentaContable}
            </SelectItem>
          </FormItem>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const precioVendido = Number(getFieldValue("precioVendido")) || 0;
              if (!precioVendido) return null;
              const diferencia = Math.round((precioVendido - valorEnLibros) * 100) / 100;
              if (diferencia > 0) {
                return <Alert type="success" message={`Utilidad en venta: ${dineroDisabledMask(diferencia)}`} />;
              } else if (diferencia < 0) {
                return <Alert type="warning" message={`Pérdida en venta: ${dineroDisabledMask(Math.abs(diferencia))}`} />;
              }
              return <Alert type="info" message="Sin utilidad ni pérdida en la venta" />;
            }}
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VenderActivo);
